<template>
  <v-container class="my-12" fluid>
    <v-row class="my-md-12 my-lg-12 my-xl-12" justify="center" no-gutters>
      <v-col lg="10" md="10" sm="10">
        <Description />
        <OverviewDesktop class="hidden-sm-and-down" :steps="steps" />
        <OverviewMobile class="hidden-md-and-up" :steps="steps" />
        <Services />
        <Pricing />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Description from "./Description";
import OverviewDesktop from "./OverviewDesktop";
import OverviewMobile from "./OverviewMobile";
import Services from "./Services";
import Pricing from "./Pricing";

export default {
  name: "Content",
  components: {
    Description,
    OverviewDesktop,
    OverviewMobile,
    Services,
    Pricing,
  },
  data: () => {
    return {
      steps: [
        {
          id: 0,
          who: "Propietario",
          title: "Crea tu carta digital",
          image: "productEditor.jpg",
          description:
            "Crea o modifica tu carta digital en cualquier momento, incluso durante un servicio.",
        },
        {
          id: 1,
          who: "Cliente",
          title: "Realiza pedidos",
          image: "placeOrder.jpg",
          description:
            "Consulta el menú, pide lo que quieras y llama al camarero desde tu móvil.",
        },
        {
          id: 2,
          who: "Cliente",
          image: "choosePayment.jpg",
          title: "Escoge la forma de pago",
          description:
            "Paga desde tu móvil o avisa al camarero para pagar con tarjeta o en efectivo.",
        },
        {
          id: 3,
          who: "Propietario",
          image: "restaurant.jpg",
          title: "Atiende a tus clientes",
          description:
            "Recibe notificaciones cuando tus clientes lleguen a la mesa, necesiten un camarero o realicen un pedido.",
        },
      ],
    };
  },
};
</script>

<style>
.title {
  font-size: 40px !important;
}
</style>
